// Module Import
//---------------------------------
import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import Field from '../../atoms/fields/field'
import 'react-datepicker/dist/react-datepicker.css'
import ValidationWrapper from '../../atoms/fields/ValidationWrapper'
import { brandError } from '../../../assets/consts/color'

// Component Import
//---------------------------------
const Form = styled.form`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  margin-bottom: 24px;
`

const BodyWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: space-between;

  span,
  label {
    line-height: 115%;
  }

  @media only screen and (max-width: 48em) {
    gap: 12px;
  }
`

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  & > div {
    flex: 1;
  }
  
  width: 100%;

  @media only screen and (min-width: 48em) and (max-width: 1450px) {
    width: 100% !important;
  }

  @media only screen and (min-width: 48em) {
    flex: ${(props) => (props?.half ? 'calc(50% - 24px)' : 'auto')};
  }
`

const FieldItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  line-height: 0;

  position: relative;
  & > div:first-child:not(.input-wrapper) {
    width: 100%;
  }

  .input-wrapper {
    width: 100%;

    label {
      position: relative;
    }

    label[aria-required='true']::after {
      position: absolute;
      top: 0;
      right: -10px;
      content: '*';
      color: ${brandError};
    }

    .error {
      font-size: 16px;
      color: ${brandError};
    }
  }
`

// Component Export
//---------------------------------
export default function CourseForm({
  formValues,
  onChange,
  errors,
  setFormRef,
}) {
  const formRef = useRef(null)
  const { emails } = formValues

  useEffect(() => {
    if (setFormRef) setFormRef(formRef)
  }, [formRef])

  return (
    <Form id="courseForm" ref={formRef}>
      <BodyWrapper>
        {emails?.map((value, i) => (
            <FieldWrapper half>
              <FieldItem>
                <ValidationWrapper errorMessage={errors?.[`emails[${i}]`]}>
                  <Field
                      labelText={`Email #${i+1}`}
                      labelFor={`email-${i}`}
                      placeholderText="test@example.com"
                      fieldType="email"
                      fieldId={`email-${i}`}
                      fieldName={`emails[${i}]`}
                      value={value}
                      fullWidth
                      onChange={onChange}
                  />
                </ValidationWrapper>
              </FieldItem>
            </FieldWrapper>
        ))}
      </BodyWrapper>
    </Form>
  )
}

CourseForm.propTypes = {}
